import { render, staticRenderFns } from "./SourceInquiryDetail.vue?vue&type=template&id=3e17fa56&scoped=true"
import script from "./SourceInquiryDetail.vue?vue&type=script&lang=js"
export * from "./SourceInquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./SourceInquiryDetail.vue?vue&type=style&index=0&id=3e17fa56&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e17fa56",
  null
  
)

export default component.exports